import { BooleanValue, StringValue } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { validatePayload } from '../../utils/validate-payload.js';
export const updateQuery = createAction('query/updateQuery', (payload) => validatePayload(payload, {
    q: new StringValue(),
    enableQuerySyntax: new BooleanValue(),
}));
